/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

const touchDevice = isTouchDevice();

if (touchDevice) {
  $(body).addClass("ismobile");
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - mouse cursor
    ========================================================================== */

const cursorsInit = function () {
  let cursor_elements = document.querySelectorAll("a, input, .filters__fieldset__field__label, .owl-dots");
  let cursor_elements_btn = document.querySelectorAll("button");
  let cursor_elements_mediavideo = document.querySelectorAll(".module--video .mediavideo");
  let white_bgs = document.querySelectorAll(".bg-white");
  const cursors = document.querySelectorAll(".cursor__circle");

  window.onload = function (e) {
    var x = window.innerWidth / 2;
    var y = window.innerHeight / 2;
    for (const cursor of cursors) {
      cursor.style = "transform: translate3d(" + x + "px, " + y + "px, 0px);";
      cursor.classList.remove("cursor__circle--hide");
    }
  };

  let moveCursor = true;

  document.addEventListener("mousemove", e => {
    if (!moveCursor) {
      return;
    }

    $(".cursor__circle").css({ transform: "translate3d(" + e.clientX + "px, " + e.clientY + "px, 0px)" });

    moveCursor = false;

    setTimeout(() => {
      moveCursor = true;
    }, 95); // The wait time. I chose 95 because it seems to work just fine for me.
  });

  cursor_elements.forEach(f => {
    let this_class = f.classList.contains("tile__link");
    f.addEventListener("mouseenter", function () {
      if (this_class) {
        cursor__tile__link($(this), true);
      } else {
        for (const cursor of cursors) {
          cursor.classList.add("on-link");
        }
      }
    });
    f.addEventListener("mouseleave", function () {
      if (this_class) {
        cursor__tile__link($(this), false);
      } else {
        for (const cursor of cursors) {
          cursor.classList.remove("on-link");
        }
      }
    });
  });

  cursor_elements_btn.forEach(f => {
    f.addEventListener("mouseenter", function () {
      for (const cursor of cursors) {
        cursor.classList.add("on-link");
      }
    });
    f.addEventListener("mouseleave", function () {
      for (const cursor of cursors) {
        cursor.classList.remove("on-link");
      }
    });
  });

  cursor_elements_mediavideo.forEach(f => {
    f.addEventListener("mouseenter", function () {
      for (const cursor of cursors) {
        cursor.classList.add("on-video");
      }
    });
    f.addEventListener("mouseleave", function () {
      for (const cursor of cursors) {
        cursor.classList.remove("on-video");
      }
    });
  });

  white_bgs.forEach(f => {
    f.addEventListener("mouseenter", function () {
      for (const cursor of cursors) {
        cursor.classList.add("override-white");
      }
    });
    f.addEventListener("mouseleave", function () {
      for (const cursor of cursors) {
        cursor.classList.remove("override-white");
      }
    });
  });
};
cursorsInit();

// @TODO Convert all to Javascript and not jquery
const cursor__tile__link = function (link, hover) {
  // let circle__main = document.querySelector(".cursor__circle__main");
  let hover_text = $(link).attr("data-linktext");

  if (hover) {
    $(".cursor__circle__main .cursor__circle__text").html(hover_text);
    let box = document.querySelector(".cursor__circle__main .cursor__circle__text");
    let width = box.clientWidth;
    let height = box.clientHeight;

    $(".cursor__circle__main").css({ width: width + "px", height: height + "px" });
    $(".cursor__circle").addClass("on-tile-link");
  } else {
    $(".cursor__circle__main .cursor__circle__text").html("");
    $(".cursor__circle__main").css({ width: "", height: "" });
    $(".cursor__circle").removeClass("on-tile-link");
  }
};

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - service accordion
    ========================================================================== */

const accordionServices = document.querySelectorAll(".accordion__service");

const serviceInit = function (serviceItems) {
  if (!serviceItems) {
    return;
  }

  serviceItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".service__item").classList.toggle("service__item--open");
    })
  );
}; // serviceInit();
serviceInit(accordionServices);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Isotype for the feature wall
    ========================================================================== */

const featureWall = document.querySelectorAll(".module--featurewall");

const featureWallInit = function (featureWallItems) {
  if (!featureWallItems) {
    return;
  }

  $(".module--featurewall .row").isotope({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: ".col-item",
    percentPosition: true,
    masonry: {
      // use element for option
      columnWidth: ".col-sizer"
    },
    gutter: 10,
    // layoutMode: "fitRows",
    rowHeight: 150
  });
}; // featureWallInit();
featureWallInit(featureWall);

/*  ==========================================================================
    GENERAL - Fancybox updates popup gallery
    ========================================================================== */

$("[data-fancybox]").fancybox({
  touch: false,
  buttons: ["close"],
  thumbs: {
    autoStart: true, // Display thumbnails on opening
    axis: "x" // Vertical (y) or horizontal (x) scrolling
  },
  btnTpl: {
    smallBtn:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="fal text-large fa-times"></i>' +
      "</button>",
    close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="fal text-large fa-times"></i>' +
      "</button>",
    arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="fal text-large fa-chevron-left"></i></div>' +
      "</button>",
    arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="fal text-large fa-chevron-right"></i></div>' +
      "</button>"
  },
  afterShow: function () {
    cursorsInit();
  },
  afterClose: function () {}
});

// /*  ==========================================================================
//     GENERAL - Contact Page popup
//     ========================================================================== */

// const new__business__popup = document.querySelector(".new__business__popup");

// const new__business__popup__control = function () {
//   if (!new__business__popup) {
//     return;
//   }
//   new__business__popup.addEventListener("click", function (e) {
//     city__popup(this, e);
//   });
// }; // new__business__popup__control();

// new__business__popup__control();

// const city__popup = function (popup__btn, e) {
//   popup__btn.classList.add("active");

//   const contactform__popup = document.querySelector(".contactform__popup .fancybox-button--close");

//   contactform__popup.addEventListener("click", function (e) {
//     const contactform__popup__inner = document.querySelectorAll(".contactform__popup__inner");
//     contactform__popup__inner.forEach(function (e) {
//       e.classList.remove("active");
//     });
//   });
// };

/*  ==========================================================================
    GENERAL - Favicon animation 
    ========================================================================== */

var favicon_images = [
    "/wp-content/themes/1HQ/img/framework/1hq-1.png",
    "/wp-content/themes/1HQ/img/framework/1hq-2.png",
    "/wp-content/themes/1HQ/img/framework/1hq-3.png"
  ],
  image_counter = 0; // To keep track of the current image

setInterval(function () {
  // remove current favicon
  if (document.querySelector("link[rel='icon']") !== null) {
    document.querySelector("link[rel='icon']").remove();
  }
  if (document.querySelector("link[rel='shortcut icon']") !== null) {
    document.querySelector("link[rel='shortcut icon']").remove();
  }
  // add new favicon image
  document
    .querySelector("head")
    .insertAdjacentHTML("beforeend", '<link rel="icon" href="' + favicon_images[image_counter] + '" type="image/gif">');

  // If last image then goto first image
  // Else go to next image
  if (image_counter === favicon_images.length - 1) {
    image_counter = 0;
  } else {
    image_counter++;
  }
}, 666);

/*  ==========================================================================
      Enable Iframe resizer for Pardot forms
      - For this to work the script also needs to be called within the iframe (e.g. in pardot)
      - the tutorial for this is here: https://jennamolby.com/how-to-embed-a-pardot-form-on-your-website-the-right-way/
      ========================================================================== */

var formIframes = document.querySelectorAll(".pardot-iframe");

if (formIframes.length) {
  formIframes.forEach(function (formIframe) {
    iFrameResize({}, formIframe);
  });
}

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    let plyrRatio = plyr.dataset.ratio;
    let plyrOptions = {
      controls: ["play", "progress", "current-time", "mute", "volume"],
      hideControls: true,
      invertTime: false,
      autoplay: false,
      ratio: plyrRatio,
      autopause: false,
      fullscreen: { enabled: false },
      tooltips: { controls: false, seek: false }
    };
    if (el.classList.contains("mediavideo--autoplay-controls")) {
      // autoplay with controls
      plyrOptions.controls = ["play", "mute", "volume"];
      plyrOptions.autoplay = true;
      plyrOptions.volume = 0;
      plyrOptions.muted = true;
      plyrOptions.loop = { active: true };
    }
    new Plyr(plyr, plyrOptions);
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;

  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
        cursorsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    FILTERING - URL Parameter functions
    ========================================================================== */

/* UPDATE URL PARAMETERS */
function filters__update_url(filter_data) {
  var url_params = "";

  $.each(filter_data, function (key, value) {
    if (!$.isEmptyObject(value)) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  });

  var page_url = window.location.href.split("?")[0];
  var new_url = page_url + url_params;

  if (history.pushState) {
    window.history.pushState({ path: new_url }, "", new_url);
  }
}

/*  ==========================================================================
			FILTERING - Filter posts
			========================================================================== */

// Get current filters data from form inputs
function filters__get_filter_data(form, filters) {
  let filter_data = {};
  $(filters).each(function () {
    filter_data[this.name] = {};
    $("input[type=checkbox][name=" + this.name + "]:checked").each(function (index) {
      filter_data[this.name][index] = $(this).val();
    });
  });
  return filter_data;
}

// Setup styling classes on new filter
function filters__update_styling(filter_data) {
  // Reset styles
  $(".filters__fieldset").removeClass("filters__fieldset--active");
  $(".filters__fieldset__field").removeClass("filters__fieldset__field--active");

  // Reset tags
  $(".filters__tags").removeClass("filters__tags--active");

  $.each(filter_data, function (key, values) {
    if (!$.isEmptyObject(values)) {
      let filter_name = key;
      // Make field group active
      $(".filters__fieldset[data-value='" + key + "']").addClass("filters__fieldset--active");
      $.each(values, function (key, value) {
        // Make input field active
        let filter_input = $("input[name='" + filter_name + "'][value='" + value + "']").closest(
          ".filters__fieldset__field"
        );
        $(filter_input).addClass("filters__fieldset__field--active");
        // Show active tags
        $(".filters__tags").addClass("filters__tags--active");
      });
    }
  });

  if ($(".filters__tags").hasClass("filters__tags--active")) {
    // Remove active class on "all work"
    $(".filters__clearall").removeClass("filters__clearall--active");
  } else {
    // add active class on "all work"
    $(".filters__clearall").addClass("filters__clearall--active");
  }
}

function filters__filter_posts() {
  // Get filters and search passed in to main.js via filters.php
  let filters = filter_settings.filters;

  let filter_data = filters__get_filter_data($(".filters"), filters);

  if (filter_data) {
    // Update filter styling and tags
    filters__update_styling(filter_data);

    // Update url
    filters__update_url(filter_data);

    // If is initial load and there is active tags on search data then trigger ajax, if not initial load then trigger everytime
    if ((filters_initial_load && $(".filters__tags").hasClass("filters__tags--active")) || !filters_initial_load) {
      filters_initial_load = false;

      // Start filtering
      $(".loadmore-container").addClass("filtering");

      // Trigger ajax
      var data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filter_data
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        beforeSend: function (xhr) {},
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // insert the posts to the container
          $(".loadmore-container").html(data.content);

          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();

          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones

          // Re-init effects
          effectsInit();

          // Re-init Cursor
          cursorsInit();

          // hide load more button, if there are not enough posts for the second page
          if (data.max_page < 2) {
            $(".paging__loadmore").hide();
          } else {
            $(".paging__loadmore").show();
          }

          // Finish filtering
          $(".loadmore-container").removeClass("filtering");
        },
        error: function (data) {}
      });
    }
  }
}

// Setup an trigger filtering
let filters_initial_load = true;

if ($(".filters").length) {
  // Filter on page load
  filters__filter_posts();

  // Filter on submit
  $(".filters").submit(function (e) {
    e.preventDefault();
    filters__filter_posts();
    // do not submit the form
    return false;
  });

  // Submit for on checkbox click
  $(".filters").on("change", "input:checkbox", function () {
    $(".filters input").not(this).prop("checked", false);
    // Update filtering
    $(".filters").submit();
  });

  // Clear all
  $(".filters__clearall").click(function () {
    // Remove all tags
    $(".filters__tags").removeClass("filters__tags--active");
    $(this).addClass("filters__clearall--active");
    // Uncheck all inputs
    $(".filters input").prop("checked", false);
    // Trigger filter
    filters__filter_posts();
  });
}

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects = false) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();

// Refresh effects animation on load
setTimeout(function () {
  effectsInit(effects);
}, 200);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const parent = elem.closest(".module--featured--carousel");
    const navigation = parent.querySelector(".featured__header .owl-nav");
    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      navContainer: navigation
    });

    cursorsInit();
    Waypoint.refreshAll();

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const imagerowCarousels = document.querySelectorAll(".imagerow--carousel .owl-carousel");

const imagerowCarouselInit = function (imagerowCarousels) {
  if (imagerowCarousels.length <= 0) {
    return;
  }

  imagerowCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    cursorsInit();

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // imagerowCarouselInit();
imagerowCarouselInit(imagerowCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavClose = document.querySelector(".mobnav-close");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    // IT'S NOT OPEN...
    body.classList.add(mobnavOpenclass);
  });
  mobnavClose.addEventListener("click", function (e) {
    e.preventDefault();

    // IT'S OPEN...
    body.classList.remove(mobnavOpenclass);
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
    GENERAL - Page Transition
    ========================================================================== */

$("a").click(function (e) {
  if (
    $(this).attr("target") !== "_blank" &&
    !$(this).hasClass("no__transition") &&
    $(this).attr("href") !== undefined &&
    !$(this).hasClass("mobnav-toggle") &&
    !$(this).hasClass("mobnav-close") &&
    !$(this).hasClass("magic__button") &&
    $(this).attr("href") !== "#" &&
    $(this).attr("href") !== "!#" &&
    !$(this).attr("href").includes("mailto:") &&
    !$(this).attr("href").includes("tel:")
  ) {
    $(".page__transition__wrapper--in").css("top", "0");
    e.preventDefault();
    const this_link = $(this).attr("href");

    // Redirect after the overlay toggle
    setTimeout(function () {
      window.location.href = this_link;
    }, 1000);
  }
});

setTimeout(function () {
  $(".page__transition__wrapper--out").css("top", "-150vh");
}, 10);

// This page show event was needed because the transition wasnt animating out on some browsers / devices
window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};

const langlinks = document.querySelectorAll(".language__button");
const siteheaderLang = document.querySelectorAll(".sitenav__item--city");
const langlinks_dropdown = document.querySelectorAll(".siteheader__nav__item__dropdown");

function mouseenterclass(evt) {
  evt.target.closest(".sitenav__item--city").classList.add("active");
}

function mouseleaveclass(evt) {
  evt.target.classList.remove("active");
}
function toggleClass(evt) {
  const parent = evt.target.closest(".sitenav__item--city");
  if (parent.classList.contains("active")) {
    parent.classList.remove("active");
  } else {
    parent.classList.add("active");
  }
}

function toggleLanguage() {
  if (window.screen.width > 1000) {
    langlinks.forEach(item => {
      item.addEventListener("mouseenter", mouseenterclass);
    });
    langlinks_dropdown.forEach(item => {
      item.addEventListener("mouseleaveclass", mouseenterclass);
    });
  } else {
    langlinks.forEach(item => {
      item.addEventListener("click", toggleClass);
    });
    langlinks_dropdown.forEach(item => {
      item.addEventListener("click", toggleClass);
    });
  }
  siteheaderLang.forEach(item => {
    item.addEventListener("mouseleave", mouseleaveclass);
  });
  langlinks_dropdown.forEach(item => {
    item.addEventListener("mouseleave", mouseleaveclass);
  });
}

toggleLanguage();

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

/*  ==========================================================================
	MAGIC BUTTON
	========================================================================== */
const magicBtnInit = function () {
  const magic__button = document.querySelector(".magic__button");

  // Open mobnav on click the toggle
  magic__button.addEventListener("click", function (e) {
    e.preventDefault();
    $(".magic__popup__slide").removeClass("magic__popup__slide--active");
    body.classList.add("magicopen");
    $(".magic__popup__slide--one").addClass("magic__popup__slide--active");
    magicPopupAnimation();
  });
}; // magicBtnInit();

magicBtnInit();

let slideTransitionOne = 1250;
let slideTransitionTwoPrep = 3000; 
let slideTransitionTwoFinish = 3500; 

const magicPopupAnimation = function () {
  const data = {
    action: "get_magic"
  };
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    success: function (data) {
      let current_url = window.location.href;

      $(window).bind("popstate", function () {
        window.location = current_url;
      });
      if (data) {
        data = JSON.parse(data);
        let pageUrl = data.url;
        let pageTitle = data.title;

        setTimeout(function () {
          slideOne();
        }, slideTransitionOne);

        $(".main").load(pageUrl + " .main", function () {
          $(this).children(":first").unwrap();

          $.ajax().done(function () {
            setTimeout(function () {
              // Set new page state after ajax
              let pagename = pageTitle + " - 1HQ";
              document.title = pagename;
              history.pushState({ pageTitle: pagename }, "", pageUrl);

              // Allow back button click
              window.onpopstate = function () {
                history.go(1);
              };

              // Scroll user to top of page
              window.scrollTo(0, 0);

              slideTwoPrep();
            }, slideTransitionTwoPrep);

            setTimeout(function () {
              
              slideTwoFinish();

              // Re-init links to make sure linklines on newly loaded content still work
              linksInit();
              // Re-init lazy load
              lazyLoadInstance.update(); // reinit lazy load after clones
              // Re-init effects
              let new_effects = document.querySelectorAll(".effect");
              effectsInit(new_effects);

              let gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");
              gridCarouselInit(gridCarousels);

              let imagerowCarousels = document.querySelectorAll(".imagerow--carousel .owl-carousel");
              imagerowCarouselInit(imagerowCarousels);

            }, slideTransitionTwoFinish);

          });
        });
      } else {
        noMagic();
      }
    }
  });
};

const slideOne = function () {
  $(".magic__popup__slide--two").addClass("magic__popup__slide--active");
}; // slideThree();

const slideTwoPrep = function () {
  $(".magic__popup__slide--two").addClass("magic__popup__slide--prep");
  $(".magic__popup__slide--one").removeClass("magic__popup__slide--active");
}; // slideThreePrep();

const slideTwoFinish = function () {
  $(".magic__popup__slide--two").addClass("magic__popup__slide--hide");
  $(".magic__popup__slide--two").removeClass("magic__popup__slide--active");
  $("body").removeClass("page-template-template-contact");
  setTimeout(function () {
    $("body").removeClass("magicopen");
    $(".magic__popup__slide--two").removeClass("magic__popup__slide--prep");
    $(".magic__popup__slide--two").removeClass("magic__popup__slide--hide");
  }, 1000);
}; // slideThreeFinish();

const noMagic = function () {
  $("body").removeClass("magicopen");
  $(".magic__popup__slide").removeClass("magic__popup__slide--active");
  $(".magic__popup__slide").removeClass("magic__popup__slide--prep");
}; // noMagic();
